import React from 'react';
import { Detector } from 'react-detect-offline';
import { errorToast } from './toast/toast';

const InternetDetector = ({ children }) => {
	return (
		<Detector
			render={({ online }) =>
				online ? (
					<>{children}</>
				) : (
					<>
						{children} {errorToast('You are offline Now !')}
					</>
				)
			}
		></Detector>
	);
};

export default InternetDetector;
